import {
  Flex,
  FormFeedback,
  ISelectOption,
  ItemDragAndDropSelector,
  Select,
  Text,
  useConfiguredForm,
} from '@wyz/ui';
import { Trans, useI18n } from '~/common/context';
import { get, isNil } from 'lodash-es';
import { IBrand, TranslationKeys } from '~/common/types';
import { Form } from '@wyz/ui';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ISupplierTemplateForm } from '~/connect/types';
import { IOptionItem } from '@wyz/types';

type Props = {
  name: string;
  brands: IBrand[];
  segments: Array<IOptionItem>;
};

function BestSourcingBrandSelector({ name, brands, segments }: Props) {
  const { t } = useI18n();
  const [brandSearch, setBrandSearch] = useState<string>('');
  const [segment, setSegment] = useState<string | undefined>(undefined);
  const { mode } = useConfiguredForm();
  const isEditMode = mode === 'WRITE';
  const methods = useFormContext<ISupplierTemplateForm>();

  return (
    <div
      className='rounded bg-light d-flex flex-column'
      style={{
        height: isEditMode ? 500 : 200,
        width: isEditMode ? '48%' : '50%',
      }}
    >
      <div className='bg-info text-center py-2 rounded-top'>
        <Text weight='semi-bold' color='info'>
          <Trans i18nKey='app.supplier_template.form.brands.title' />
        </Text>
      </div>
      {!isNil(methods) && (
        <FormFeedback invalid id={`${name}.error`}>
          <Trans
            i18nKey={
              (
                get(methods.formState.errors, name) as
                  | { message?: string }
                  | undefined
              )?.message as keyof TranslationKeys
            }
          />
        </FormFeedback>
      )}
      <Flex direction='column' className='p-2 flex-1 overflow-y-auto'>
        {isEditMode && (
          <>
            <Text>
              <Trans i18nKey='app.common.datatable.filter.select.placeholder' />
            </Text>
            <Select<false, ISelectOption<string>>
              name='segment'
              placeholder={t('app.supplier_template.form.segment')}
              onChange={(e) => setSegment(e?.value ?? undefined)}
              options={segments}
              isClearable
            />
            <Text color='secondary' className='mt-2'>
              <Trans i18nKey='app.common.buttons.search' />
            </Text>
            <Form.Control
              type='text'
              onChange={(e) => setBrandSearch(e.target.value)}
            />
          </>
        )}
        <ItemDragAndDropSelector
          name={name}
          items={brands
            .filter((brand) => {
              if (!isNil(segment) && brand.segment.publicKey !== segment) {
                return false;
              }
              return brand.name
                .toLowerCase()
                .includes(brandSearch.trim().toLowerCase());
            })
            .map((brand) => ({
              label: brand.name,
              value: brand.publicKey,
            }))}
          availableItemsLabel={t('app.supplier_template.form.brands.available')}
          selectedItemsLabel={t('app.supplier_template.form.brands.selected')}
          allowSelectAll={true}
          translate={t}
        />
      </Flex>
    </div>
  );
}

export default BestSourcingBrandSelector;
